var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopping = function SvgShopping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M58.67 19.55h-3.56v-7.11c0-4.9-3.99-8.89-8.89-8.89s-8.89 3.99-8.89 8.89v7.11h-3.56v-7.11C33.77 5.58 39.35 0 46.21 0s12.44 5.58 12.44 12.44v7.11Zm-30.22 1.78V32h17.33l4 32h6.72c4.14 0 7.5-3.36 7.5-7.5V21.33H28.44ZM46.23 64H0l3.56-28.44h39.11zM35.56 49.93a1.5 1.5 0 0 0-2.12.02c-2.74 2.8-6.4 4.34-10.32 4.34s-7.58-1.54-10.32-4.34a1.5 1.5 0 0 0-2.14 2.1c3.31 3.38 7.73 5.24 12.46 5.24s9.15-1.86 12.46-5.24a1.5 1.5 0 0 0-.02-2.12"
  })));
};
export default SvgShopping;